"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _getCookie = require("../services/getCookie");

var _TicketMessage = require("./TicketMessage.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TicketNotFound = function TicketNotFound(_ref) {
  var ticketsLink = _ref.ticketsLink;
  var email = (0, _getCookie.getCookie)('watchMail');
  return /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicket, {
    id: "popup-ticket"
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTwoCol, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColRight, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "We could not find any associated tickets with the provided email", Boolean(email) && " - ".concat(email)), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "If you have a ticket to the event, please double check the email used to register on", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: ticketsLink,
    target: "_blank"
  }, "Ti.to"), ' ', "or digital badges and enter your email below"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketForm, {
    action: "/live",
    method: "get",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketField, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketInput, {
    type: "email",
    name: "email",
    placeholder: "Your email"
  }), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketSubmitButton, {
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unlock"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketArrowSvg, null, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "img/sprite.svg#icon-arrow-right"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '30px'
    }
  }), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "If you don't have a ticket, please register via our", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: ticketsLink,
    target: "_blank"
  }, "Ti.to"), ' ', "page."))));
};

var _default = TicketNotFound;
exports.default = _default;